// extracted by css-extract-rspack-plugin
export default {"footerRoot":"footerRoot-M3TIUt","footerLink":"footerLink-l2foYE"};